module.exports = __webpack_public_path__ + "img/checkmark.152133cc.gif";